import React, { useState } from "react";

const FieldEditor = ({ field, editField, setEditingField }) => {
  const [label, setLabel] = useState(field.label);
  const [placeholder, setPlaceholder] = useState(field.placeholder);
  const [options, setOptions] = useState(field.options.join("\n"));
  const [text, setText] = useState(field.text);

  const handleSave = () => {
    const updatedField = {
      ...field,
      label,
      text,
      placeholder,
      options: options.split("\n"), // Split by line break for dropdown options
    };
    editField(field.id, updatedField);
    setEditingField(null); // Close the editor after saving
  };

  return (
    <div id="edit-block">
      <h4>Edit {field.type}</h4>
      {field.type !== "Checkbox" && (
        <>
          {field.type === "SingleLine" && (
            <>
                <label>Placeholder:</label>
                <input
                    type="text"
                    value={placeholder}
                    onChange={(e) => setPlaceholder(e.target.value)}
                />
            </>
          )}
          {field.type === "MultiLine" && (
            <>
            <label>
              Placeholder:</label>
              <input
                type="text"
                value={placeholder}
                onChange={(e) => setPlaceholder(e.target.value)}
              />
              </>
          )}
        </>
      )}
      {field.type === "RadioSelect" && (
            <>
        <label>
          Label:</label>
          <input
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
          />
          </>
      )}
      {field.type === "Checkbox" && (
            <>
        <label>
          Label:</label>
          <input
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
          />
          </>
      )}
      {field.type === "Dropdown" && (
            <>
        <label>
          Options (one per line):</label>
          <textarea
            value={options}
            onChange={(e) => setOptions(e.target.value)}
          />
          </>
      )}
      {field.type === "Heading" && (
            <>
        <label>
          Heading Text:</label>
          <input
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          </>
      )}
      {field.type === "Text" && (
            <>
        <label>
          Text:</label>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          </>
      )}
      {field.type === "Label" && (
            <>
        <label>
          Label text:</label>
          <input
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          </>
        
      )}
      <br/>
      <br/>
      <button onClick={handleSave}>Save</button>
      <button onClick={() => setEditingField(null)}>Cancel</button>
    </div>
  );
};

export default FieldEditor;
